module.exports = __webpack_public_path__ + "static/media/moduleSet_i0o0.78b74806.jpg";